export default "__VITE_ASSET__Dvmem9pX__"